export default "__VITE_ASSET__DXKqjae7__"